<div class="container-fluid py-4 px-3 px-md-5">
  <div class="card shadow-lg mx-auto border-0 rounded-4" style="max-width: 1000px;">
    <div
      class="card-header text-center py-3"
      style="background-color: #1e3a8a; color: white; border-radius: 0.8rem 0.8rem 0 0;"
    >
      <h3 class="mb-0 fw-semibold">Agregar Nuevo Producto</h3>
    </div>

    <div class="card-body bg-light p-4 p-md-5">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

        <!-- === Identificación === -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Identificación</h5>
        <div class="row g-3 mb-4">

          <div class="col-md-4">
            <label class="form-label fw-semibold">Código</label>
            <input type="number" formControlName="codigo" class="form-control form-control-lg" placeholder="Ej: 1001" />
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">Código INE</label>
            <input type="text" formControlName="codigoINE" class="form-control form-control-lg" placeholder="Ej: P-001" />
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">Nombre</label>
            <input type="text" formControlName="nombre" class="form-control form-control-lg" placeholder="Nombre del producto" />
          </div>
        </div>

        <!-- === Clasificación === -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Clasificación</h5>

        <div class="row g-3 mb-4">
          <div class="col-md-3">
            <label class="form-label fw-semibold">Sección</label>
            <input type="number" formControlName="fkSeccion" class="form-control form-control-lg" placeholder="Ej: 1" />
          </div>

          <div class="col-md-3">
            <label class="form-label fw-semibold">División</label>
            <input type="number" formControlName="fkDivision" class="form-control form-control-lg" placeholder="Ej: 2" />
          </div>

          <div class="col-md-3">
            <label class="form-label fw-semibold">Clase</label>
            <input type="number" formControlName="fkClase" class="form-control form-control-lg" placeholder="Ej: 3" />
          </div>
        </div>

        <!-- === Ponderaciones === -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Ponderaciones</h5>

        <div class="row g-3 mb-4">
          <div class="col-md-4">
            <label class="form-label fw-semibold">Ponderación</label>
            <input type="number" step="0.000000000000000001" formControlName="ponderacion" class="form-control form-control-lg" />
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">Ponderación Importado</label>
            <input type="number" step="0.000000000000000001" formControlName="ponderacionImportado" class="form-control form-control-lg" />
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">Ponderación General</label>
            <input type="number" step="0.000000000000000001" formControlName="ponderacionGeneral" class="form-control form-control-lg" />
          </div>
        </div>

        <!-- === Códigos de Clasificación === -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Códigos de Clasificación</h5>

        <div class="row g-3 mb-4">

          <div class="col-md-3">
            <label class="form-label fw-semibold">Código CIIU</label>
            <input type="text" formControlName="codigoCIIU" class="form-control form-control-lg" />
          </div>

          <div class="col-md-3">
            <label class="form-label fw-semibold">Código NAEG</label>
            <input type="text" formControlName="codigoNAEG" class="form-control form-control-lg" />
          </div>

          <div class="col-md-3">
            <label class="form-label fw-semibold">Código NPG</label>
            <input type="text" formControlName="codigoNPG" class="form-control form-control-lg" />
          </div>

          <div class="col-md-3">
            <label class="form-label fw-semibold">Código CCP</label>
            <input type="text" formControlName="codigoCCP" class="form-control form-control-lg" />
          </div>

        </div>

        <!-- === Contenido adicional === -->
        <h5 class="text-primary border-bottom pb-2 mb-3">Información Complementaria</h5>

        <div class="row g-3 mb-4">

          <div class="col-md-4">
            <label class="form-label fw-semibold">Canasta</label>
            <select class="form-select form-select-lg" formControlName="canasta">
              <option value="A">A</option>
              <option value="I">I</option>
            </select>
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">Referencia</label>
            <input type="text" formControlName="referencia" class="form-control form-control-lg" />
          </div>

          <div class="col-md-4">
            <label class="form-label fw-semibold">Estado</label>
            <select formControlName="estado" class="form-select form-select-lg">
              <option value="A">Activo</option>
              <option value="I">Inactivo</option>
            </select>
          </div>

        </div>

        <!-- === Botón Guardar === -->
        <div class="text-center mt-4">
          <button type="submit" class="btn btn-lg btn-primary px-5 py-2 shadow-sm rounded-pill" [disabled]="form.invalid || loading()">
            @if (loading()) {
              <span class="spinner-border spinner-border-sm"></span> Guardando...
            } @else {
              <i class="bi bi-save me-2"></i> Guardar
            }
          </button>
        </div>

        @if (success()) {
          <div class="alert alert-success mt-4 text-center rounded-pill shadow-sm">
            Producto registrado correctamente.
          </div>
        }

        @if (error()) {
          <div class="alert alert-danger mt-4 text-center rounded-pill shadow-sm">
            {{ error() }}
          </div>
        }

      </form>
    </div>
  </div>
</div>
